<template>
  <div
    class="position-department"
    :class="hasDepartment ? 'position-department--assigned' : 'position-department--none'"
    data-testid="position-department"
  >
    <span class="position-department__icon" aria-hidden="true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.61"
        height="16.61"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M7.97222 1.35938H6.02778C5.59822 1.35938 5.25 1.7076 5.25 2.13715V3.30382C5.25 3.73337 5.59822 4.0816 6.02778 4.0816H7.97222C8.40178 4.0816 8.75 3.73337 8.75 3.30382V2.13715C8.75 1.7076 8.40178 1.35938 7.97222 1.35938Z"
          stroke="currentColor"
          stroke-width="1.24444"
        />
        <path
          d="M4.08355 9.91406H2.13911C1.70955 9.91406 1.36133 10.2623 1.36133 10.6918V11.8585C1.36133 12.2881 1.70955 12.6363 2.13911 12.6363H4.08355C4.51311 12.6363 4.86133 12.2881 4.86133 11.8585V10.6918C4.86133 10.2623 4.51311 9.91406 4.08355 9.91406Z"
          stroke="currentColor"
          stroke-width="1.24444"
        />
        <path
          d="M11.8609 9.91406H9.91645C9.48689 9.91406 9.13867 10.2623 9.13867 10.6918V11.8585C9.13867 12.2881 9.48689 12.6363 9.91645 12.6363H11.8609C12.2904 12.6363 12.6387 12.2881 12.6387 11.8585V10.6918C12.6387 10.2623 12.2904 9.91406 11.8609 9.91406Z"
          stroke="currentColor"
          stroke-width="1.24444"
        />
        <path
          d="M7.00022 4.08594V6.41927M3.11133 9.91927V7.19705H10.8891V9.91927"
          stroke="currentColor"
          stroke-width="1.24444"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>

    <template v-if="hasDepartment">
      <EXTooltip v-if="isTruncated" placement="top" :title="trimmedDepartment" :delay="300">
        <span class="position-department__name" tabindex="0">{{ trimmedDepartment }}</span>
      </EXTooltip>
      <span v-else class="position-department__name">{{ trimmedDepartment }}</span>
    </template>
    <span v-else class="position-department__name position-department__name--muted">
      No department
    </span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import EXTooltip from "@components/tooltip/EXTooltip.vue";

const TRUNCATE_AFTER_CHARS = 20;

const props = defineProps({
  department: {
    type: String,
    default: "",
  },
});

const trimmedDepartment = computed(() => (props.department ?? "").trim());

const hasDepartment = computed(() => trimmedDepartment.value.length > 0);

const isTruncated = computed(() => trimmedDepartment.value.length > TRUNCATE_AFTER_CHARS);
</script>

<style scoped>
.position-department {
  display: flex;
  align-items: center;
  gap: 4.15px;
  height: 25px;
  min-width: 0;
}

.position-department__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16.61px;
  height: 16.61px;
  color: #666666;
}

.position-department--none .position-department__icon {
  color: #98a2b3;
}

.position-department__name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  color: #101828;
  font-family: Inter;
  font-size: 10.38px;
  font-weight: 500;
  line-height: 24.91px;
}

.position-department__name:focus-visible {
  outline: 2px solid #6941c6;
  outline-offset: 2px;
}

.position-department__name--muted {
  color: #98a2b3;
}
</style>
